import React from "react";

import TextField from "@material-ui/core/TextField";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import StepContent from "@material-ui/core/StepContent";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import NumberFormat from "react-number-format";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";

import { useStyles } from "./questions-styles";

const CurrencyFormat = (props) => {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator
      isNumericString
      prefix="$"
    />
  );
};

export default ({
  activeStep,
  handlePreviousStep,
  handleNextStep,

  age,
  isAgeValid,
  handleAgeChange,

  startingCapital,
  handleStartingCapitalChange,

  monthlyDeposit,
  handleMonthlyDepositChange,

  riskToleranceMod,
  handleRiskToleranceModChange,
  riskToleranceOptions,

  handleInputKeyPress,
}) => {
  const classes = useStyles();

  const steps = [
    {
      label: "🧑 Возраст",
      instructions: "Сколько Вам лет?",
      input: (
        <TextField
          id="age-input"
          autoFocus
          placeholder="Возраст"
          value={age}
          error={!isAgeValid}
          helperText={!isAgeValid && "Брокерский счёт можно открыть после 21."}
          required
          type="number"
          inputProps={{
            min: 21,
          }}
          onChange={handleAgeChange}
          onKeyPress={handleInputKeyPress}
        />
      ),
    },
    {
      label: "💰 Начальный капитал",
      instructions: "Какой размер Вашего начального капитала?",
      caption: "Рекомендуется начинать от $12,000.",
      input: (
        <TextField
          id="starting-capital-input"
          autoFocus
          placeholder="Начальный капитал"
          value={startingCapital}
          required
          onChange={handleStartingCapitalChange}
          onKeyPress={handleInputKeyPress}
          InputProps={{
            inputComponent: CurrencyFormat,
          }}
        />
      ),
    },
    {
      label: "💵 Ежемесячный вклад",
      instructions: "Какую сумму Вы будете добавлять каждый месяц?",
      caption: "Обычно 10% от активного дохода.",
      input: (
        <TextField
          id="monthly-deposit-input"
          autoFocus
          placeholder="Ежемесячный вклад"
          value={monthlyDeposit}
          required
          onChange={handleMonthlyDepositChange}
          onKeyPress={handleInputKeyPress}
          InputProps={{
            inputComponent: CurrencyFormat,
          }}
        />
      ),
    },
    ...(startingCapital >= 10_000
      ? [
          {
            label: "📉 Аппетит к риску",
            instructions: "Какой уровень риска вы позволяете?",
            input: (
              <RadioGroup
                value={riskToleranceMod}
                onChange={handleRiskToleranceModChange}
              >
                {riskToleranceOptions.map((option) => (
                  <FormControlLabel
                    key={option.value}
                    control={<Radio />}
                    label={option.label}
                    value={option.value}
                  />
                ))}
              </RadioGroup>
            ),
          },
        ]
      : []),
  ];

  const renderStep = (step) => (
    <Step key={step.label}>
      <StepLabel>{step.label}</StepLabel>
      <StepContent>
        <Typography>{step.instructions}</Typography>
        {step.caption && (
          <Typography variant="caption" component="p">
            {step.caption}
          </Typography>
        )}

        {step.input}
        <div className={classes.actionsContainer}>
          {activeStep !== 0 && (
            <Button
              className={classes.button}
              disabled={activeStep === 0}
              onClick={handlePreviousStep}
            >
              Назад
            </Button>
          )}
          <Button
            className={classes.button}
            variant="contained"
            color="primary"
            onClick={handleNextStep}
            disabled={
              !isAgeValid ||
              (activeStep === 1 && !startingCapital) ||
              (activeStep === 3 && riskToleranceMod === null)
            }
          >
            {activeStep === steps.length - 1 ? "Расчитать" : "Вперед"}
          </Button>
        </div>
      </StepContent>
    </Step>
  );

  return (
    <Stepper
      className={classes.root}
      activeStep={activeStep}
      orientation="vertical"
    >
      {steps.map((step) => renderStep(step))}
    </Stepper>
  );
};
